/* eslint-disable max-len */
import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
  Button,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Cancel } from '../../media/images/Cancel';
import DraggableUnitTable from '../../Common/DraggableTable.tsx/DraggableUnitTable';
import { RootState } from '../../redux/rootState';
import { UnitListing } from '../Job/ScreenBidWorkSheetJob/utils/types';
import { saveUnitOrder } from '../Job/ScreenBidWorkSheetJob/redux/bidWorksheetSlice';

interface IReOrderUnitsModal {
  open: boolean;
  handleClose: () => void;
  handleData: () => void;
}

const Datatablestyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  // height: 'fit-content',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: '6px 24px 24px 24px',
  height: 'auto',
  // minHeight: '450px',
  // '@media (max-width: 768px)': {
  //   p: '6px 6px 15px',
  //   height: 'auto',
  // },
};

export default function ReOrderUnitsModal({
  open, handleClose, handleData,
}: IReOrderUnitsModal) {
  const dispatch = useDispatch();
  const { unitList } = useSelector((state:RootState) => state.bidsReducer);
  const { bidId } = useParams();
  const [items, setItems] = useState<UnitListing[]>([]);
  const closeModal = () => {
    handleClose();
  };
  const callback = () => {
    handleData();
    handleClose();
  };
  const handleSave = () => {
    const pay = {
      BidId: bidId,
      Units: items?.map((item, index) => ({
        UnitId: item?.UnitId,
        Order: index + 1,
      })),
    };
    dispatch(saveUnitOrder({ pay, handleData: callback }));
  };

  return (
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={Datatablestyle}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            Re-order Unit List
          </div>
          <div className="cancel-icon" onClick={() => closeModal()}>
            <Cancel />
          </div>
        </div>
        <div>
          <div className="draggable-header">UNIT ID  |  SERIAL  |  MODEL  |  TUBE COUNT  |  PRICE</div>
          <DraggableUnitTable data={unitList} items={items} setItems={setItems} />
        </div>
        <div className="save_and_next_div">
          <div>
            <Button className="button_cancel" onClick={closeModal}>Cancel</Button>
          </div>
          <div className="button_margin_left" style={{ marginTop: '20px' }}>
            <Button className="button_save_and_next" onClick={handleSave}>Save</Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
